import { useState, useEffect, useMemo } from 'react'
import PanelCarsLoading from "components/Result/Skeleton/PanelCarsLoading"
import BannerEvent from "components/Customs/Banner/Horizontal/BannerEvent"
import ModalValidation from 'components/Result/Modal/ModalValidation'
import PanelDetailCar from "components/Result/Cars/PanelDetailCar"
import MenuSortDesktop from 'components/Result/MenuSortDesktop'
import AlertSearchingCar from 'components/Result/Scheduled/AlertSearchingCar'
import MediaQuery from 'react-responsive'
import { useDispatch } from 'react-redux'
import { useModal } from 'hooks/useModal'

const PanelViewRight = ({
    listResultCar = [],
    handleQuoteCar,
    actionAdvertising,
    isLoadingResult,
    getFileCar,
    goToConcesionaire,
    addCompareCar,
    titleHeader,
    menuSort,
    setMenuSort,
    countResult
}) => {
    const { isOpen, closeModal } = useModal(false)
    const dispatch = useDispatch()
    const [currentPage, setCurrentPage] = useState(1)
    const carsPerPage = 30

    // Reset page when new results arrive
    useEffect(() => {
        setCurrentPage(1)
    }, [listResultCar])

    // 1. Eliminar duplicados en base a id o key
    const cleanListResultCar = useMemo(() => {
        const map = new Map()
        listResultCar.forEach(car => {
            // Generar ID único si no existe
            const uniqueId = car.id || car.key || `${car.model}-${car.price}-${car.year}-${car.color}`
            if (!map.has(uniqueId)) {
                map.set(uniqueId, car)
            }
        })
        return Array.from(map.values())
    }, [listResultCar])

    // 2. Filtrar, ordenar DESC por precio y desempate por modelo
    const autosOrdenados = useMemo(() => {
        return cleanListResultCar
            .filter(car => !car.isBanner && Number(car.price) > 0)
            .sort((a, b) => {
                const priceDiff = Number(b.price) - Number(a.price)
                if (priceDiff !== 0) return priceDiff
                // Desempate por modelo alfabético
                return (a.model || '').localeCompare(b.model || '')
            })
    }, [cleanListResultCar])

    // 3. Obtener banners aparte
    const banners = useMemo(() => cleanListResultCar.filter(car => car.isBanner), [cleanListResultCar])

    // 4. Calcular total páginas
    const totalPages = Math.ceil(autosOrdenados.length / carsPerPage)

    // 5. Obtener autos para la página actual
    const startIndex = (currentPage - 1) * carsPerPage
    const autosPagina = useMemo(() => {
        return autosOrdenados.slice(startIndex, startIndex + carsPerPage)
    }, [autosOrdenados, startIndex, carsPerPage])


    // Detectar duplicados en autosPagina por id o key
    useEffect(() => {
        const ids = autosPagina.map(c => c.id || c.key)
        const duplicates = ids.filter((id, idx) => ids.indexOf(id) !== idx)
        if (duplicates.length > 0) {
            console.warn('Autos duplicados en la página actual:', duplicates)
        }
    }, [autosPagina])

    return (
        <div className="col-xs-12 col-md-9">
           {/* <AlertSearchingCar />*/}

            <div className="search-result">
                <div>
                    <h1 className="search-result__title">{titleHeader}</h1>
                    <p className="search-result__small">{countResult} Resultados</p>

                    {/* Lista simple de autos con precios 
          <div
            style={{
              border: '1px solid #ccc',
              padding: '10px',
              maxHeight: '300px',
              overflowY: 'auto',
              marginBottom: '1rem'
            }}
          >
            {autosPagina.map((auto, idx) => (
              <p key={auto.key || auto.id || idx}>
                {auto.model || auto.name || 'Sin nombre'} - ${Number(auto.price).toLocaleString('es-CL')}
              </p>
            ))}
          </div>*/}
                </div>

                {/* <MediaQuery minWidth={768}>
                    <div className="options-search__container">
                        <p
                            className="options-search__type options-search--order d-none d-md-block"
                            onClick={() => setMenuSort(!menuSort)}
                            style={{ cursor: 'pointer' }}
                        >
                            Ordenar
                        </p>
                        {menuSort && <MenuSortDesktop setMenuSort={setMenuSort} />}
                    </div>
                </MediaQuery>*/}
            </div>

            <div className="card-cars-flex">
                {!isLoadingResult && autosPagina.length > 0 && (
                    <>
                        {/* Renderizamos autos ordenados en la página */}
                        {autosPagina.map(item => (
                            <PanelDetailCar
                                key={item.key || item.id || `${item.model}-${item.price}-${item.color}-${item.year}`}
                                {...item}
                                idKey={item?.key}
                                listado={[]}
                                addCompareCar={addCompareCar}
                                viewCar={getFileCar}
                                handleQuoteCar={handleQuoteCar}
                                goToConcesionaire={goToConcesionaire}
                                consesionaire={item.concessionaire}
                            />
                        ))}

                        {/* Renderizamos banners separados */}
                        {banners.map((bannerItem, idx) => (
                            <BannerEvent
                                key={`banner-${idx}`}
                                imagen={bannerItem.banners}
                                functionModal={actionAdvertising}
                                title="Banner"
                                classContainer="mb-0"
                                classPicture="mb-0 car-banner__detail banner-result"
                                classMain="banner-num__result"
                            />
                        ))}
                    </>
                )}

                {isLoadingResult && Array.from({ length: 5 }).map((_, index) => (
                    <PanelCarsLoading key={`skeleton-${index}`} />
                ))}
            </div>

            {/* Sin resultados */}
            {!isLoadingResult && autosPagina.length === 0 && (
                <div className="error_not_search mt-5">
                    <img src="https://api-news.movicenter.cl/misc/no-encontrado.png" alt="No hay búsqueda" />
                </div>
            )}

            {/* Paginador */}
            {!isLoadingResult && totalPages > 1 && (
                <div className="pagination mt-4 d-flex justify-content-center gap-2">
                    {(() => {
                        const buttons = []
                        const total = totalPages
                        const current = currentPage

                        if (total <= 7) {
                            // Mostrar todos los botones si son 7 o menos
                            for (let i = 1; i <= total; i++) {
                                buttons.push(i)
                            }
                        } else {
                            // Siempre mostrar el 1
                            buttons.push(1)

                            let left = current - 1
                            let right = current + 1

                            if (current <= 3) {
                                left = 2
                                right = 4
                            } else if (current >= total - 2) {
                                left = total - 3
                                right = total - 1
                            }

                            // Si hay espacio para "..." después del 1
                            if (left > 2) {
                                buttons.push('left-ellipsis')
                            }

                            // Rango de números centrales
                            for (let i = left; i <= right; i++) {
                                if (i > 1 && i < total) {
                                    buttons.push(i)
                                }
                            }

                            // Si hay espacio para "..." antes del último
                            if (right < total - 1) {
                                buttons.push('right-ellipsis')
                            }

                            // Siempre mostrar el último
                            buttons.push(total)
                        }

                        return buttons.map((page, idx) => {
                            if (page === 'left-ellipsis' || page === 'right-ellipsis') {
                                return <span key={page + idx} className="pagination-ellipsis">...</span>
                            }

                            return (
                                <button
                                    key={page}
                                    onClick={() => setCurrentPage(page)}
                                    className={`btn btn-sm ${currentPage === page ? 'btn-primary' : 'btn-outline-primary'}`}
                                >
                                    {page}
                                </button>
                            )
                        })
                    })()}
                </div>
            )}


            {isOpen && <ModalValidation isOpen={isOpen} closeModal={closeModal} />}
        </div>
    )
}

export default PanelViewRight
